(() => {
  const stickyAtc = document.querySelector('.sticky-atc');
  if (!stickyAtc) return;

  const productFormWrap = document.querySelector('.ProductForm');
  if (!productFormWrap) return;

  const stickyAtcBtn = document.getElementById('sticky-atc-btn');
  if (!stickyAtcBtn) return;
  let hasUserScrolled = false;
  let ctaMutationObserver;

  const SCROLL_BOTTOM_THRESHOLD = 4;

  function getMainCta() {
    return productFormWrap.querySelector('.ProductForm__AddToCart');
  }

  function syncStickyButtonState() {
    const atc = getMainCta();
    if (atc) {
      stickyAtcBtn.innerHTML = atc.innerHTML;
      stickyAtcBtn.disabled = atc.disabled;
    }
  }

  function watchMainCta() {
    if (ctaMutationObserver) {
      ctaMutationObserver.disconnect();
    }

    const atc = getMainCta();
    if (!atc) return;

    ctaMutationObserver = new MutationObserver(() => {
      syncStickyButtonState();
    });

    ctaMutationObserver.observe(atc, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function getViewportTopInset() {
    const header = document.getElementById('shopify-section-header');
    if (header && header.offsetHeight > 0) {
      return header.offsetHeight;
    }
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
      .trim();
    const px = parseFloat(raw);
    return Number.isFinite(px) ? px : 0;
  }

  function isMainCtaVisible() {
    const atc = getMainCta();
    if (!atc) return false;
    const br = atc.getBoundingClientRect();
    const topInset = getViewportTopInset();
    return br.bottom > topInset && br.top < window.innerHeight;
  }

  function isAtPageBottom() {
    const layoutHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const visibleBottom = window.scrollY + window.innerHeight;
    return visibleBottom >= layoutHeight - SCROLL_BOTTOM_THRESHOLD;
  }

  function updateStickyBar() {
    if (!hasUserScrolled) {
      stickyAtc.classList.add('active');
      return;
    }

    if (isAtPageBottom()) {
      stickyAtc.classList.remove('active');
      return;
    }

    if (isMainCtaVisible()) {
      stickyAtc.classList.remove('active');
    } else {
      stickyAtc.classList.add('active');
    }
  }

  window.addEventListener(
    'scroll',
    () => {
      hasUserScrolled = true;
      updateStickyBar();
    },
    { passive: true }
  );
  window.addEventListener('resize', updateStickyBar, { passive: true });

  stickyAtcBtn.addEventListener('click', () => {
    const atc = getMainCta();
    if (atc) {
      atc.click();
      requestAnimationFrame(syncStickyButtonState);
    }
  });

  document.addEventListener('variant:changed', () => {
    watchMainCta();
    syncStickyButtonState();
    updateStickyBar();
  });

  if (!getMainCta()) return;

  stickyAtc.classList.add('active');
  watchMainCta();
  syncStickyButtonState();
  updateStickyBar();
})();
